import { setLoading } from "redux/actions/app.actions";
import { openNotificationWithIcon } from "../utils/Notification";
import { request } from "./verb.services";
import { getStateAndCountryFromZip } from "./locationCenter.services";
import { getServerErrorString } from "utils/common";

export const getAllAddresses = (guestId, showLoading = true) => {
  return (dispatch) => {
    if (showLoading) dispatch(setLoading(true));
    return request(`Guests/Addresses?guestId=${guestId}`, "get", null, true)
      .then((response) => {
        // dispatch(setAddresses(response.data));
        return {
          status: "success",
          data: response.data,
        };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        if (showLoading) dispatch(setLoading(false));
      });
  };
};

export const createAddress = (guestId, data) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    const address = data.address
    const { state, country, zipCode } = await getStateAndCountryFromZip(
      address
    );
    if (!state || !country || !zipCode) {
      dispatch(setLoading(false));
      openNotificationWithIcon(
        "error",
        "Error!",
        "Please enter a valid street address"
      );
      return;
    }
    return request(
      `Guests/Addresses?guestId=${guestId}`,
      "post",
      {
        address,
        state: state,
        country: country,
        zipCode: zipCode,
      },
      {
        contentType: "application/json",
      }
    )
      .then((response) => {
        // dispatch(getAllAddresses());
        openNotificationWithIcon(
          "success",
          "Success!",
          "Your address has been added successfully"
        );
        return { status: "success", data: response?.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};

export const setPrimaryAddress = (guestId, addressId) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Guests/Addresses/${addressId}/Primary?guestId=${guestId}`,
      "patch",
      null,
      true
    )
      .then((response) => {
        // dispatch(setPrimaryAddressAction(addressId));
        openNotificationWithIcon(
          "success",
          "Success!",
          "Your primary address has been updated successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const setAddressInstruction = (guestId, addressId, data) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Guests/Addresses/${addressId}/Instructions?guestId=${guestId}`,
      "patch",
      JSON.stringify(data.instructions),
      {
        contentType: "application/json",
      }
    )
      .then((response) => {
        // dispatch(
        //   updateAddressAction({
        //     instructions: data.instructions,
        //     addressId: addressId,
        //   })
        // );
        openNotificationWithIcon(
          "success",
          "Success!",
          "Instructions for the address have been updated successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const updateAddress = (guestId, addressId, data) => {
  return async (dispatch) => {
    dispatch(setLoading(true));
    const address = data.address
    const { state, country, zipCode } = await getStateAndCountryFromZip(
      address
    );
    if (!state || !country || !zipCode) {
      dispatch(setLoading(false));
      openNotificationWithIcon(
        "error",
        "Error!",
        "Please enter a valid street address"
      );
      return;
    }
    return request(
      `Guests/Addresses/${addressId}?guestId=${guestId}`,
      "put",
      {
        address,
        state,
        country,
        zipCode,
      },
      true
    )
      .then((response) => {
        openNotificationWithIcon(
          "success",
          "Success!",
          "Address has been updated successfully"
        );
        return { status: "success", data: response?.data };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };
};

export const deleteAddress = (guestId, id) => {
  return (dispatch) => {
    dispatch(setLoading(true));
    return request(
      `Guests/Addresses/${id}?guestId=${guestId}`,
      "delete",
      null,
      true
    )
      .then((response) => {
        // dispatch(deleteAddressAction(id));
        openNotificationWithIcon(
          "success",
          "Success!",
          "Address removed successfully"
        );
        return { status: "success" };
      })
      .catch((e) => {
        openNotificationWithIcon(
          "error",
          "Error!",
          getServerErrorString(e)
        );
      })
      .finally(() => dispatch(setLoading(false)));
  };
};
